import {Component} from '@angular/core';

@Component({
    selector: 'db-orders',
    templateUrl: './orders.component.html',
    styleUrls: ['./orders.component.scss'],
    standalone: false
})
export class OrdersComponent {

}
